/**
 * @fileoverview PUT handler for the "/:app_group_id/campaign_qa_runs/:campaign_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { campaignQaRunCacheKeys } from "./constants";
import type { PutCampaignQaRunProps, PutCampaignQaRunResult } from "./types";

export const putCampaignQaRun = reactQueryMutationAdapter(
  campaignQaRunCacheKeys,
  (props: PutCampaignQaRunProps): Promise<PutCampaignQaRunResult> => {
    return fetch(
      `/${props.appGroupId}/campaign_qa_runs/${props.campaignId}`,
      "PUT",
      {
        run_id: props.runId,
        // Undefined drops the key from the JSON body entirely, so the
        // controller's guarded assignment never runs.
        selected_agent_ids: props.selectedAgentIds,
        results: props.results,
        rule_resolutions: props.ruleResolutions,
        last_run_at: props.lastRunAt,
      },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
